exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-0f00fdee]{text-align:center;margin-top:15px}.login[data-v-0f00fdee]{text-align:center}.terms[data-v-0f00fdee]{margin-top:15px}.term-link[data-v-0f00fdee]{margin-top:10px;margin-bottom:24px}.home[data-v-0f00fdee]{text-align:center;margin-top:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0f00fdee","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/auth/register.vue
// module id = Nblt
// module chunks = 0